<template>
    <div class="inventory-shelve">
        <v-row class="inventory-shelve__row">
            <v-col
                cols="12"
                md="6"
            >
                <ClInput
                    ref="scan"
                    v-model="scan"
                    type="text"
                    autofocus
                    placeholder="Scan a Shelf or Product"
                    prependInnerIcon="mdi-book-open-variant"
                    @keyup.enter="processScan()"
                />
            </v-col>
            <v-col
                cols="12"
                md="6"
                class="shelf"
            >
                <ShelfHeading
                    :locator="locator"
                    :loading="shelfInFlight"
                />
                <ClButton
                    type="secondary"
                    class="shelf__change"
                    @click="clearAll()"
                >
                    Clear All
                </ClButton>
                <ClButton
                    v-if="false"
                    type="secondary"
                    class="shelf__change"
                    :elevation="0"
                    @click="clearShelf(); focusScan()"
                >
                    Change
                </ClButton>
            </v-col>
        </v-row>
        <v-row class="inventory-shelve__row">
            <v-col cols="12" class="table-heading">
                <ScanTableHeading
                    :locator="locator"
                    :scannedAmount="scannedItems.length"
                />
            </v-col>
            <v-col cols="12">
                <ClTableSimple
                    :items="scannedItems"
                    :headers="headers"
                    height="45vh"
                    class="shelving-table"
                    fixedHeader
                >
                    <template #[`item.status`]="{ item }">
                        <ItemStatus :item="item" />
                    </template>
                    <template #[`item.remove`]="{ item }">
                        <ClButton
                            v-if="item.status !== 'complete' && item.status !== 'loading'"
                            aria-label="Remove Item"
                            icon
                            @click="removeItemAndFocusScan( item )"
                        >
                            <v-icon>mdi-delete-outline</v-icon>
                        </ClButton>
                    </template>
                </ClTableSimple>
            </v-col>
        </v-row>
        <v-row class="inventory-shelve__row">
            <v-col
                cols="12"
                class="table-heading"
            >
                <span>Shelved Items History</span>
            </v-col>
            <v-col cols="12">
                <ClTableSimple
                    :items="shelvedItems"
                    :headers="shelvedHeaders"
                    :itemsPerPage="50"
                    height="45vh"
                    class="shelving-table"
                    itemKey="subId"
                    fixedHeader
                    showFooter
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
// Vuex
import { mapState, mapActions, mapMutations } from 'vuex';

// Components
import ItemStatus from '@/views/shared/ItemStatus';
import ShelfHeading from '@/views/shared/ShelfHeading';
import ScanTableHeading from '@/views/shared/ScanTableHeading';

export default {
    name: 'InventoryShelve',
    components: {
        ItemStatus,
        ShelfHeading,
        ScanTableHeading,
    },
    data() {
        return {
            headers: [
                {
                    text: 'Item ID',
                    value: 'serial',
                    width: '25%',
                },
                {
                    text: 'Title',
                    value: 'title',
                    width: '25%',
                },
                {
                    text: 'Source',
                    value: 'source',
                },
                {
                    text: 'Status',
                    value: 'status',
                    // Minimize width as much as possible
                    // Will still have enough width to contain contents
                    width: 0,
                },
                {
                    text: '',
                    value: 'remove',
                    width: 0,
                },
            ],
            shelvedHeaders: [
                {
                    text: 'Item ID',
                    value: 'serial',
                },
                {
                    text: 'Title',
                    value: 'title',
                },
                {
                    text: 'Source',
                    value: 'source',
                },
                {
                    text: 'Destination',
                    value: 'destination',
                },
            ],
        };
    },
    computed: {
        ...mapState( {
            scanString: ( state ) => state.Inventory.Shelve.scanString,
            scannedItems: ( state ) => state.Inventory.Shelve.scannedItems,
            shelvedItems: ( state ) => state.Inventory.Shelve.shelvedItems,
            shelfInFlight: ( state ) => state.Inventory.Shelve.shelfInFlight,
            locator: ( state ) => state.Inventory.Shelve.locator,
        } ),
        scan: {
            get() {
                return this.scanString;
            },
            set( scanString ) {
                this.$store.commit( 'Inventory/Shelve/SET_SCAN_STRING', { scanString } );
            },
        },
    },
    beforeDestroy() {
        this.$store.dispatch( 'Inventory/Shelve/reset' );
    },
    methods: {
        ...mapActions( {
            processScan: 'Inventory/Shelve/processScan',
        } ),
        ...mapMutations( {
            clearShelf: 'Inventory/Shelve/RESET_LOCATOR',
            clearTable: 'Inventory/Shelve/RESET_SCANNED_ITEMS',
            removeScannedItem: 'Inventory/Shelve/REMOVE_SCANNED_ITEM',
        } ),
        focusScan() {
            this.$nextTick( () => {
                this.$refs.scan.$el.querySelector( 'input' ).focus();
            } );
        },
        clearAll() {
            this.clearTable();
            this.clearShelf();
            this.focusScan();
        },
        removeItemAndFocusScan( item ) {
            this.removeScannedItem( item );
            this.focusScan();
        },
    },
};
</script>

<style lang="scss" scoped>
.inventory-shelve {
    margin-top: 2rem;
    &__row {
        align-items: center;

        .shelf {
            display: flex;
            align-items: center;
            justify-content: space-between;
            &__change {
                margin-left: 1rem;
            }
            @include mixins-above(tablet) {
                justify-content: flex-end;
            }
        }
        .table-heading {
            padding-bottom: 0;
        }
        .shelving-table {
            border: 1px solid rgba( 0, 0, 0, .38 );
            overflow-y: auto;
            &:hover {
                border: 1px solid rgba( 0, 0, 0, .87 );
            }
        }
    }
}

</style>
